import type { ConfigureIntegrationResult } from '@cli-types/next-adapter/runtime.js'
import { appendEnvVars } from '@cli-utils/files.js'
import { collectR2Config } from './collect-r2-config.js'

export async function promptR2Config(cwd: string): Promise<ConfigureIntegrationResult> {
  const collected = await collectR2Config(cwd)
  const envResult = appendEnvVars(cwd, collected.sections, collected.overwriteKeys)

  return {
    configured: true,
    addedEnvKeys: envResult.added,
    updatedEnvKeys: envResult.updated
  }
}
